import { useQuery } from "@tanstack/react-query";

import { useDsdTaskStatus } from "@/components/sidebar/hooks";
import { canRunWorkbookWideAction } from "@/components/sidebar/task-status";
import queries from "@/queries";

/**
 * 워크북 전체 대상 액션(전체 오토태깅·전체 표 불러오기)의 활성화 조건.
 *
 * 워크북 분석 완료(status) 와 시트별 분석 진행(task status) 두 축을 함께 본다.
 * 판정 자체는 순수 함수 `canRunWorkbookWideAction` 이 소유하고(테스트가 거기 있다),
 * 이 훅은 두 쿼리를 물어다 주기만 한다. 전체 단위 조건이 바뀌면 그 함수만 고친다.
 *
 * 시트 단위 액션은 이 훅을 쓰지 않는다 — `useIsCurrentSheetAnalyzing` 몫이다(WXBRL-2182).
 */
export function useCanRunWorkbookWideAction(
  workbookId: string | undefined,
): boolean {
  const { data: dsdList } = useQuery({
    ...queries.dsd(),
    enabled: !!workbookId,
  });
  const { data: taskStatus } = useDsdTaskStatus(workbookId);

  if (!workbookId) return false;
  return canRunWorkbookWideAction(
    dsdList?.find((workbook) => workbook.id === workbookId)?.status,
    taskStatus,
  );
}
